export function TriDivider() {
  return (
    <div className="tri-divider">
      <div className="rule" />
      <div className="tri" />
      <div className="rule" />
    </div>
  );
}
